import { render, staticRenderFns } from "./GraphDetail88.vue?vue&type=template&id=d99d4404&scoped=true"
import script from "./GraphDetail88.vue?vue&type=script&lang=js"
export * from "./GraphDetail88.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d99d4404",
  null
  
)

export default component.exports